import { create } from 'zustand'

export interface StreamingState {
  sessionId: string | null
  isStreaming: boolean
  streamingContent: string
  skillName: string | null
  error: string | null
}

interface StreamingStore extends StreamingState {
  startStream: (sessionId: string, skillName?: string | null) => void
  appendToken: (content: string) => void
  setStreamContent: (content: string) => void
  setStreamError: (error: string) => void
  stopStream: () => void
  reset: () => void
}

const initialState: StreamingState = {
  sessionId: null,
  isStreaming: false,
  streamingContent: '',
  skillName: null,
  error: null,
}

export const useStreamingStore = create<StreamingStore>((set) => ({
  ...initialState,
  startStream: (sessionId, skillName = null) =>
    set({ sessionId, isStreaming: true, streamingContent: '', skillName, error: null }),
  appendToken: (content) =>
    set((state) => ({ streamingContent: state.streamingContent + content })),
  setStreamContent: (content) => set({ streamingContent: content }),
  setStreamError: (error) => set({ error, isStreaming: false }),
  stopStream: () =>
    set((state) => ({
      isStreaming: false,
      // Streaming-Content kurz behalten, damit ein Ruecksprung ins Chat-Tab
      // den letzten Stand noch sieht. Wird beim naechsten Start ueberschrieben.
      streamingContent: state.isStreaming ? state.streamingContent : '',
      skillName: null,
      error: null,
    })),
  reset: () => set(initialState),
}))

export function selectStreamingSession(state: StreamingState): StreamingState {
  return state
}
